import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findRedPacket = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket?`+params,
        method: 'GET'
    })
}

export const findRedPacketAll = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket`,
        method: 'GET'
    })
}

export const findRedPacketDetail = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/details?`+params,
        method: 'GET'
    })
}

export const addRedPacket = (data) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket`,
        method: 'POST',
        data: data
    })
}
export const immediatePay = (data) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/immediatePay`,
        method: 'POST',
        data: data
    })
}
export const editRedPacket = (data) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket`,
        method: 'PUT',
        data: data
    })
}

export const delRedPacket = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales/v1/redPacket/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}